import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPointsSection() {
  const points = ['Querés arrancar en detailing… pero seguís perdiendo tiempo, plata y confianza', 'Saltás de video en video… y cuanto más mirás, menos claro tenés qué hacer', 'Cada error te puede costar plata, clientes y hacerte abandonar antes de empezar'];
  return <section className="py-16 px-4 bg-[#0a0a0a] border-y border-gray-800/50 pt-[44px] pb-[44px] pl-[14px] pr-[14px] mt-[0px] mb-[0px] relative overflow-hidden" data-id="element-180">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(circle_at_center,rgba(239,68,68,0.08),transparent_70%)] pointer-events-none" data-id="element-181" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-182">
        <motion.h2 initial={{
        opacity: 0,
        y: -20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="md:text-4xl font-black text-center mb-10 text-brand-yellow text-[26px] uppercase tracking-tighter italic" data-id="element-183">
          Si te sentís así, esto es para vos
        </motion.h2>

        <div className="space-y-4 md:space-y-6" data-id="element-184">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.15,
          duration: 0.6,
          ease: [0.23, 1, 0.32, 1]
        }} whileHover={{
          scale: 1.02,
          y: -5
        }} className="group flex items-center gap-5 p-5 md:p-7 rounded-3xl border border-white/5 bg-gradient-to-br from-[#151515] to-[#0a0a0a] shadow-[0_20px_50px_rgba(0,0,0,0.5)] hover:border-red-500/30 transition-all duration-500 relative overflow-hidden" data-id="element-185">
              {/* Premium glass effect */}
              <div className="absolute inset-0 bg-gradient-to-tr from-red-500/0 via-red-500/0 to-red-500/[0.03] opacity-0 group-hover:opacity-100 transition-opacity duration-700" data-id="element-186" />

              <div className="relative flex-shrink-0" data-id="element-187">
                <div className="absolute inset-0 bg-red-600/30 blur-xl rounded-full group-hover:bg-red-500/50 transition-all duration-500 scale-150" data-id="element-188" />
                <div className="relative z-10 w-10 h-10 md:w-12 md:h-12 rounded-2xl bg-gradient-to-br from-red-500 to-red-700 flex items-center justify-center shadow-[0_0_20px_rgba(239,68,68,0.4)] group-hover:shadow-[0_0_30px_rgba(239,68,68,0.6)] transition-all duration-500" data-id="element-189">
                  <XCircle className="w-6 h-6 md:w-7 md:h-7 text-white" strokeWidth={2.5} data-id="element-190" />
                </div>
              </div>

              <p className="text-lg md:text-xl text-gray-100 font-bold leading-tight relative z-10 group-hover:text-white transition-colors w-full tracking-tight" data-id="element-191">
                {point}
              </p>

              {/* Decorative accent */}
              <div className="absolute right-0 top-0 w-32 h-32 bg-red-500/5 blur-[50px] rounded-full -mr-16 -mt-16 group-hover:bg-red-500/10 transition-colors duration-700" data-id="element-192" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}